/**
 * Helpers de enmascarado para info sensible mostrada al rol VIEWER.
 *
 * IMPORTANTE: este enmascarado es SOLO visual. El dato real está en el doc
 * Firestore que el viewer puede leer (las rules permiten read a cualquier
 * autenticado). Cualquier viewer con conocimiento técnico puede abrir
 * devtools y leer el campo crudo.
 *
 * Para seguridad real habría que servir esos campos vía endpoint del
 * worker que los enmascare server-side y prohibir read directo en
 * firestore.rules. Por ahora, enmascarado client-side es suficiente para
 * "no leer al pasar" / capturas de pantalla casuales.
 */

/**
 * `juan.perez@gmail.com` → `j***@gmail.com`
 * `xy@example.com`       → `x***@example.com`
 */
export function maskEmail(email) {
  if (!email || typeof email !== 'string') return '—';
  const at = email.indexOf('@');
  if (at < 1) return '***';
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  const head = local[0] || '*';
  return `${head}***@${domain}`;
}

/**
 * `juancreator` → `j***`
 * `xy`          → `x***`
 */
export function maskHandle(handle) {
  if (!handle || typeof handle !== 'string') return null;
  const head = handle[0] || '*';
  return `${head}***`;
}
